import { Tooltip } from '@mantine/core'
import { IconHelp } from '@tabler/icons-react'

type Props = {
  text: string
}

export default function HelpTooltip({ text }: Props) {
  return (
    <Tooltip multiline maw={250} label={text} withArrow>
      <IconHelp size={16} />
    </Tooltip>
  )
}
